<div id="messages-list">
  <div *ngIf="totalMessagesCount" class="list-table messages">
    <ng-container
      *ngIf="environment.SYSTEM_CODE === 'CO' && messageList.length"
    >
      <div class="top-table-filters-pagination">
        <div class="top-table-filters">
          <label class="search-field-with-icon">
            <span class="visually-hidden" i18n="@@Filter messages"
              >Filter messages</span
            >
            <input
              type="text"
              [(ngModel)]="searchPhrase"
              i18n-placeholder="@@Filter messages"
              placeholder="Filter messages"
              (ngModelChange)="onSearchPhraseChange()"
            />
            <i class="fa-regular fa-magnifying-glass"></i>
          </label>
        </div>
        <div class="top-table-pagination">
          <pagination-controls
            *ngIf="totalMessagesCount && messageList.length"
            class="list-pagination messages"
            id="messages"
            [autoHide]="true"
            (pageChange)="onMessagePageChange($event)"
            [previousLabel]="globalStateProviderService.previousLabel"
            [nextLabel]="globalStateProviderService.nextLabel"
          ></pagination-controls>
        </div>
      </div>
    </ng-container>
    <div
      class="filters-container messages"
      *ngIf="environment.SYSTEM_CODE !== 'CO'"
    >
      <div class="list-column">
        <label>
          <span class="visually-hidden" i18n="@@Filter messages"
            >Filter messages</span
          >
          <input
            type="text"
            [(ngModel)]="searchPhrase"
            i18n-placeholder="@@Filter messages"
            placeholder="Filter messages"
            (ngModelChange)="onSearchPhraseChange()"
          />
        </label>
      </div>
    </div>
    <div class="list-container">
      <div
        class="list-item"
        *ngFor="
          let message of messageList
            | paginate
              : {
                  id: 'messages',
                  itemsPerPage: 10,
                  currentPage: currentMessagePage,
                  totalItems: currentMessagesCount
                };
          let i = index
        "
        [ngClass]="{
          seen: message.is_seen,
          open: message.isOpen,
          marked: message.marked
        }"
        style="--listIndex: {{ i }}"
      >
        <div class="message-header" (click)="toggleMessage(message)">
          <div class="list-column message-subject">
            <i [hidden]="message.isOpen" class="fal fa-chevron-down"></i>
            <i [hidden]="!message.isOpen" class="fal fa-chevron-up"></i>
            <div class="message-metadata">
              <span class="message-metadata-subject">{{
                message.subject
              }}</span>
              <div class="message-metadata-info">
                <span i18n="@@from">from</span>
                <span class="message-metadata-from">{{
                  message.message_from_institution_name
                }}</span>
                <span i18n="@@at">at</span>
                <span class="message-metadata-date">{{
                  message.created_at | date: DATETIME_FORMAT
                }}</span>
              </div>
            </div>
          </div>
          <i
            class="fal fa-trash-alt delete-message"
            #popover="bs-popover"
            [popover]="deleteTemplate"
            [popoverContext]="{ $implicit: message }"
            popoverTitle="Confirmation"
            i18n-popoverTitle="@@Confirmation"
            triggers="click"
            (click)="
              registerPopover(message.id, popover); $event.stopPropagation()
            "
          ></i>
        </div>
        <div
          class="message-body"
          *ngIf="message.isOpen"
          [innerHTML]="message.content"
        ></div>
      </div>
    </div>
  </div>
  <pagination-controls
    *ngIf="
      totalMessagesCount &&
      messageList.length &&
      environment.SYSTEM_CODE !== 'CO'
    "
    class="list-pagination messages"
    id="messages"
    [autoHide]="true"
    (pageChange)="onMessagePageChange($event)"
    [previousLabel]="globalStateProviderService.previousLabel"
    [nextLabel]="globalStateProviderService.nextLabel"
  ></pagination-controls>
  <div
    *ngIf="!messageList.length && totalMessagesCount"
    class="no-match-results"
  >
    <div i18n="@@No matching messages" class="system-message info">
      No matching messages
    </div>
    <div class="actions">
      <button
        i18n="@@Reset filters"
        (click)="resetFilters()"
        class="btn btn-primary"
      >
        Reset filters
      </button>
    </div>
  </div>
  <div *ngIf="!totalMessagesCount" class="empty-list">
    <div i18n="@@parta-my-messages-not-found" class="system-message info">
      Message list is empty
    </div>
  </div>
</div>

<ng-template #deleteTemplate let-message>
  <p i18n="@@Do you want to delete this message?" class="popover-body-text">
    Do you want to delete this message?
  </p>
  <div class="popover-buttons">
    <button
      class="btn btn-primary btn-danger btn-sm"
      (click)="deleteMessage(message); hidePopover(message.id)"
      i18n="Delete message"
    >
      Delete message
    </button>
    <button
      class="btn btn-secondary btn-sm"
      (click)="hidePopover(message.id)"
      i18n="Cancel"
    >
      Cancel
    </button>
  </div>
</ng-template>
